<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'PaMudik',

    metaInfo: { title: 'PA Mudik' },

    extends: View,

    mixins: [
      LoadSections([
        'pa-mudik',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'pamudik',
      },
    },
  }
</script>
